import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const FullScreen = ({
  title = 'FullScreen',
  className,
  viewBox = '0 0 24 25',
  fill = 'currentColor',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} className={className} viewBox={viewBox} fill="none" {...props}>
    <path d="M11 5.86279H19V13.8628" stroke={fill} strokeWidth="2" strokeLinecap="round" />
    <path d="M13 19.8628L5 19.8628L5 11.8628" stroke={fill} strokeWidth="2" strokeLinecap="round" />
    <path d="M19 5.86279L5 19.8628" stroke={fill} strokeWidth="2" />
  </CreateIconComponent>
);

export default FullScreen;
